import axios from 'axios';
const url = 'https://api.app-lab.be-keeper.com/benefits';
// const url = `${process.env.API}/benefits`;

//Benefits routes
export const fetchBenefits = () => axios.get(url);
export const createBenefits = (newBenefit) => axios.post(url, newBenefit);
export const deleteBenefit = (id) => axios.delete(`${url}/${id}`);
